exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description-area[data-v-7205d8d6]{overflow:scroll;word-wrap:break-word;overflow-wrap:break-word}[data-v-7205d8d6]::-webkit-scrollbar{width:10px!important;height:3px!important}[data-v-7205d8d6]::-webkit-scrollbar:vertical{display:block}[data-v-7205d8d6]::-webkit-scrollbar-thumb,[data-v-7205d8d6]::-webkit-scrollbar-thumb:hover{display:block;background:var(--charity-primary)}.btn-text[data-v-7205d8d6]{font-size:20px!important}.m-neg[data-v-7205d8d6]{padding-top:-10px;padding-left:-10px}.text-direction[data-v-7205d8d6]{direction:rtl!important}.new-line[data-v-7205d8d6]{white-space:pre}", ""]);

// exports
